import { render, staticRenderFns } from "./addition.vue?vue&type=template&id=3061d3c6&scoped=true&"
import script from "./addition.vue?vue&type=script&lang=js&"
export * from "./addition.vue?vue&type=script&lang=js&"
import style0 from "./addition.vue?vue&type=style&index=0&id=3061d3c6&lang=less&scoped=true&"
import style1 from "./addition.vue?vue&type=style&index=1&id=3061d3c6&lang=less&scoped=true&"
import style2 from "./addition.vue?vue&type=style&index=2&id=3061d3c6&lang=less&scoped=true&"
import style3 from "./addition.vue?vue&type=style&index=3&id=3061d3c6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3061d3c6",
  null
  
)

export default component.exports